
import { onMounted, reactive, ref } from "vue";
import XAtable from "@/components/XATable.vue";
import { sysNameQueryList, sysNameSave } from "@/api/api";
import { message } from "ant-design-vue";

interface SearchFormState {
  adsId: string;
  userId: string;
  status: string;
  pageNo: number;
  pageSize: number;
}

export default {
  name: "BacklogManage",
  components: {
    XAtable,
  },
  setup() {
    const searchFormState = reactive<SearchFormState>({
      adsId: "",
      userId: "",
      status: "",
      pageNo: 1,
      pageSize: 10,
    });

    const pageNo = ref(1);
    const total = ref(0);
    const loading = ref(false);
    const searchFormRef = ref();

    const columns = reactive([
      {
        title: "ID",
        key: "id",
        dataIndex: "id",
        width: 80,
      },
      {
        title: "广告账户ID",
        key: "adsId",
        dataIndex: "adsId",
        width: 180,
      },
      {
        title: "母BMID",
        key: "bmBase",
        dataIndex: "bmBase",
        width: 150,
      },
      {
        title: "指纹ID",
        key: "fingerId",
        dataIndex: "fingerId",
        width: 180,
      },
      {
        title: "原广告名称",
        key: "sourceName",
        dataIndex: "sourceName",
        width: 200,
      },
      {
        title: "新广告名称",
        key: "adsName",
        dataIndex: "adsName",
        width: 200,
      },
      {
        title: "用户名称",
        key: "userName",
        dataIndex: "userName",
        width: 120,
        slots: {
          customRender: "userName",
        },
      },
      {
        title: "状态",
        key: "status",
        dataIndex: "status",
        width: 100,
        slots: {
          customRender: "status",
        },
      },
      {
        title: "创建时间",
        key: "createTime",
        dataIndex: "createTime",
        width: 180,
      },
      {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
        width: 180,
      },
      {
        title: "操作",
        key: "control",
        dataIndex: "control",
        width: 180,
        fixed: "right",
        slots: {
          customRender: "control",
        },
      },
    ]);

    const tableData = ref([]);

    const search = () => {
      searchFormState.pageNo = 1;
      getData();
    };

    const resetForm = () => {
      searchFormState.pageNo = 1;
      searchFormRef.value.resetFields();
      getData();
    };

    const getData = () => {
      loading.value = true;
      sysNameQueryList(searchFormState).then((res) => {
        loading.value = false;
        if (res.code === "200") {
          total.value = res.data.total;
          tableData.value = res.data.records;
        }
      });
    };

    const pageNoChange = (val: number) => {
      searchFormState.pageNo = val;
      getData();
    };

    const onShowSizeChange = (current: number, size: number) => {
      searchFormState.pageSize = size;
      getData();
    };

    // 处理待办或忽略
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (row: any, status: number) => {
      const statusText = status === 1 ? "处理" : "忽略";
      sysNameSave({
        id: row.id,
        status: status,
        adsId: row.adsId,
        userId: row.userId,
        beginTime: row.beginTime,
        endTime: row.endTime,
      }).then((res) => {
        if (res.code === "200") {
          message.success(`${statusText}成功！`);
          getData();
        } else {
          message.error(res.message || `${statusText}失败！`);
        }
      });
    };

    onMounted(() => {
      getData();
    });

    return {
      searchFormState,
      searchFormRef,
      columns,
      tableData,
      pageNo,
      total,
      loading,
      search,
      resetForm,
      pageNoChange,
      onShowSizeChange,
      handleClick,
    };
  },
};
